module.exports = function clone(obj) {
  return JSON.parse(JSON.stringify(obj));
};



//////////////////
// WEBPACK FOOTER
// /Applications/MAMP/htdocs/newton/wp-content/themes/newton/node_modules/instantsearch.js/node_modules/algoliasearch/src/clone.js
// module id = 44
// module chunks = 0